import { Button, DatePicker } from '@repo/ui';
import { useCallback, useMemo, useState } from 'react';

import { LedgerReportForm as FormValues } from '../../types';

type Props = {
  values: FormValues;
  onChange: (values: FormValues) => void;
  onCancel: () => void;
  onGenerate: () => void;
};

export default function LedgerReportForm({ values, onChange, onCancel, onGenerate }: Props) {
  const [mode, setMode] = useState<'all' | 'custom'>('all');
  const updateFormValues = useCallback(
    (patch: Partial<FormValues>) => {
      onChange({ ...values, ...patch });
    },
    [values, onChange]
  );

  const isDisableGenerate = useMemo(
    () => mode === 'custom' && (!values.dateRange.to || !values.dateRange.from),
    [mode, values.dateRange]
  );

  return (
    <div className="p-2 flex flex-col gap-4">
      <div>
        <h6>Report Period</h6>
        <div className="grid grid-cols-2 gap-4 mt-4">
          <Button
            variant={`${mode === 'all' ? 'primary' : 'outline'}`}
            onClick={() => setMode('all')}
          >
            All Transaction
          </Button>
          <Button
            variant={`${mode === 'custom' ? 'primary' : 'outline'}`}
            onClick={() => setMode('custom')}
          >
            Custom Date Range
          </Button>
        </div>
      </div>

      <div className={`grid grid-cols-2 gap-4 mt-2 ${mode !== 'custom' ? 'hidden' : ''}`}>
        <DatePicker
          mode="single"
          label="Start Date"
          placeholder="Pick a date"
          value={values.dateRange.from}
          onChange={fromDate =>
            updateFormValues({ dateRange: { ...values.dateRange, from: fromDate } })
          }
        />
        <DatePicker
          mode="single"
          label="End Date"
          placeholder="Pick a date"
          value={values.dateRange.to}
          onChange={toDate => updateFormValues({ dateRange: { ...values.dateRange, to: toDate } })}
        />
      </div>
      <div className="grid grid-cols-3 gap-4 mt-2">
        <Button variant="outline" onClick={onCancel} className="col-start-2">
          Cancel
        </Button>

        <Button
          variant="primary"
          disabled={isDisableGenerate}
          onClick={onGenerate}
        >
          {/* {loading ? 'Generating...' : 'Generate Report'} */}
          Generate Report
        </Button>
      </div>
    </div>
  );
}
